import { useEffect, FunctionComponent } from 'react';

// Components
import { useFormikContext } from 'formik';
import Field, { FieldPhoneNumber } from '../Field';
import ButtonLoading from '@Components/UI/ButtonLoading';

// Utilities
import classnames from 'classnames';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Form.module.scss';

interface FormProps {
    tab?: string;
    loading?: boolean;
    className?: string;
}

const Form: FunctionComponent<FormProps> = ({ tab, loading, className }) => {
    const { deviceType } = useViewDetected();
    const { handleSubmit, isValid, resetForm } = useFormikContext();

    useEffect(() => {
        resetForm();
    }, [tab]);

    const renderFieldWithTab = () => {
        switch (tab) {
            case 'doctor':
                return <Field className={styles.field} name="specialist" placeholder="Chuyên khoa của Bác sĩ" />;
            case 'clinic':
                return (
                    <>
                        <Field className={styles.field} name="clinicName" placeholder="Tên phòng khám, cơ sở y tế" />

                        <Field className={styles.field} name="clinicAddress" placeholder="Địa chỉ phòng khám, cơ sở y tế" />
                    </>
                );
            case 'nursing':
                return (
                    <>
                        <div className={styles.hint}>Vui lòng cho biết khu vực bạn có thể làm việc (Tỉnh / Thành / Quận / Huyện)</div>
                        <Field className={styles.field} name="address" placeholder="Khu vực có thể làm việc" />
                    </>
                );
            case 'enterprise':
                return (
                    <>
                        <Field className={styles.field} name="enterpriseName" placeholder="Tên doanh nghiệp" />

                        <Field className={styles.field} name="enterpriseMember" placeholder="Số lượng nhân viên đăng ký khám" type={deviceType !== 'desktop' ? 'number' : 'text'} />
                    </>
                );
            default:
                return null;
        }
    };

    const wrapperClassName = classnames([styles.wrapper, className]);

    return (
        <form onSubmit={handleSubmit} className={wrapperClassName}>
            <Field className={styles.field} name="name" placeholder="Tên người liên hệ" />

            <FieldPhoneNumber className={styles.field} name="phoneNumber" placeholder="Nhập số điện thoại" />

            {renderFieldWithTab()}

            <Field className={styles.field} name="email" placeholder="Email liên hệ" />

            <div className={styles.btn_wrapper}>
                <ButtonLoading disabled={!isValid} loading={loading} className={styles.btn_submit} type="submit">
                    Gửi thông tin
                </ButtonLoading>
            </div>
        </form>
    );
};

Form.defaultProps = {
    className: '',
};

export default Form;
